import { find } from 'lodash';
import axios from 'axios';

import { MYMIGROS_SET_IS_FETCHING, MYMIGROS_SET_SLIDERS } from 'reducers/actions-types';

/**
 * @param {IMyMigrosSlider} slider
 * @return {Function<IMyMigrosFetchedSliders>}
 */
function filterCategoryById(slider) {
    /** @var{IMyMigrosFetchedSliders} fetchedSlider */
    return (fetchedSlider) => {
        if (!fetchedSlider.category || !fetchedSlider.category.id) {
            return false;
        }

        return slider.id === fetchedSlider.category.id;
    };
}

/**
 * We populate the existing sliders that are set initially with the freshly loaded products
 * @param {IMyMigrosSlider[]} sliders
 * @param {IMyMigrosFetchedSliders[]} fetchedSliders
 * @return {IMyMigrosSlider};
 */
function populateSliders(sliders, fetchedSliders) {
    return sliders.map((slider) => {
        /** @var {IMyMigrosFetchedSliders} fetchedSlider */
        const fetchedSlider = find(fetchedSliders, filterCategoryById(slider));
        if (!fetchedSlider) {
            return slider;
        }
        slider.products = fetchedSlider.products;
        return slider;
    });
}

/**
 * Fetch all products
 * @param {IMyMigrosSlider[]} sliders
 * @param {string} apiEndpoint
 * @return {Promise<IMyMigrosSlider[]>}
 */
export function fetchCategoryProducts(sliders, apiEndpoint) {
    return (dispatch) => {
        dispatch({ type: MYMIGROS_SET_IS_FETCHING, isFetching: true });
        return axios.get(apiEndpoint)
            .then(
                /**
                 * @param {IMyMigrosFetchedSliders[]} data
                 */
                ({ data }) => {
                    const categoryProducts = populateSliders(sliders, data);
                    dispatch({ type: MYMIGROS_SET_SLIDERS, sliders: categoryProducts });
                    dispatch({ type: MYMIGROS_SET_IS_FETCHING, isFetching: false });
                    return categoryProducts;
                });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/mymigros/helpers.js